import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';
import Swal from 'sweetalert2';

import './Home.css';

 /*
* This displays a bootstrap modal that allows the user to change assessment ownership.
* Set the property show = true to show the modal, false to close it.
*/

class ChangeOwnerModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newOwnerId: 0,
            newOwnerUsername: null,
            changeOwnerButtonDisabled: false
        }
    }

    changeOwnershipHandler = () => {

        if (isNullOrEmpty(this.state.newOwnerId) || isNaN(this.state.newOwnerId) || isNullOrEmpty(this.state.newOwnerUsername)) {
            alertPopup('error', "Please specify both a CADE ID and associated Username in order to change ownership");
            return false;
        }

        // Set the button label, make an api request to change.  On success, change the button label to success.
        let confirmMsg = "You are about to transfer ownership of ALL assessments associated with " + this.props.firstName + " " + this.props.lastName + " to CADE User " + this.state.newOwnerUsername + " having ID " + this.state.newOwnerId + ". ";
        confirmMsg = confirmMsg + "The CADE User ID that you entered must be associated with the CADE username that you specified (if not, the request will be denied).  ";
        confirmMsg = confirmMsg + "After you change ownership, you will continue to have access to these assessments. Do you still want to proceed?";

        // Didn't want to enclose the remainder of this function as a callback and can't simply 'return' so using Swal inline in this instance
        Swal.fire({
            text: confirmMsg,
            icon: 'warning',
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showCancelButton: true,
            showConfirmButton: true,
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ changeOwnerButtonDisabled: true });
                let changeOwnerData = {
                    providerId: this.props.providerId,
                    newOwnerId: this.state.newOwnerId,
                    newOwnerUsername: this.state.newOwnerUsername,
                    personFirstName: this.props.firstName,
                    personLastName: this.props.lastName,
                    personBirthDate: this.props.birthDate
                };

                let url = "account/" + this.props.providerId + "/changeowner/";
                api.post(url, changeOwnerData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + authService.token
                        }
                    })
                    .then((response) => {

                        // Success is an OK (200) status code
                        if (response.status == 200) {
                            alertPopup('success', "Ownership changed.");
                            this.setState({ changeOwnerButtonDisabled: false });
                            setTimeout(() => { this.props.closeHandler(true); }, 1000);
                            return;
                        }
                        else {
                            apiErrorPopup(apiResponseHandler(response));
                            return;
                        };
                    })
                    .catch((error) => {
                        // Major problem - should not happen.
                        apiErrorPopup(apiErrorHandler(error));
                        return;
                    });
            }
            else if (result.isDenied) {
                return;
            }
        });
    }

    usernameChangeHandler = (e) => {
        this.setState({ newOwnerUsername: e.target.value });
    }

    idChangeHandler = (e) => {
        this.setState({ newOwnerId: e.target.value });
    }

    render() {
        
        return (
            <Fragment>
                <Modal
                    show={this.props.show}
                    onHide={this.props.closeHandler.bind(this, false)}
                    backdrop="static"
                    className="modal"
                    onClick={(e) => { e.stopPropagation(); }}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Change Ownership of All Assessments for {this.props.firstName} {this.props.lastName} {this.props.birthDate}</Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="newOwnerId">
                                <Form.Label>New Owner CADE ID</Form.Label>
                                <Form.Control id="newOwnerId" onChange={this.idChangeHandler} type="number" value={this.state.newOwnerId} placeholder="The CADE ID of the person to which you wish to transfer ownership" />
                            </Form.Group>
                            <Form.Group controlId="newOwnerUsername">
                                <Form.Label>New Owner CADE Username</Form.Label>
                                <Form.Control id="newOwnerUsername" onChange={this.usernameChangeHandler} type="text" value={this.state.newOwnerUsername} placeholder="The CADE Username of the person o which you wish to transfer ownership" />
                            </Form.Group>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.props.closeHandler.bind(this, false)}>Close</Button>
                        <Button variant="primary" onClick={this.changeOwnershipHandler} disabled={this.state.changeOwnerButtonDisabled} > Change Owner</Button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

export default ChangeOwnerModal;


// WEBPACK FOOTER //
// ./src/components/Home/ChangeOwnerModal.js